const GUIDELINES_PATH = '/community-guidelines';

/**
 * The guidelines page sits inside the creator shell, which resolves its creator from
 * `?creatorId=` (creator-shell.tsx). Without that param the shell has no creator and
 * the header stays on its loading skeleton.
 */
export function buildCommunityGuidelinesHref(creatorId?: string) {
  return creatorId
    ? `${GUIDELINES_PATH}?creatorId=${encodeURIComponent(creatorId)}`
    : GUIDELINES_PATH;
}
